import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Heading from '../CommonResp/Heading/Heading';
import Breadcrumbs from '../CommonResp/BreadcrumbsWithoutSchema/Breadcrumbs';
import ReverseTile from './ReverseTile/ReverseTile';
import SortBy from './SortBy/SortBy';
import Listing from './Listing/Listing';
import Tile from '../CommonResp/Tile/Tile'
import { routeDataSelector, srpDataSelector, srpPrivateBusesSelector, srpRTCBusesSelector, dumpDataSelector, busAvailableSelector, routePageFilterSelector } from './../RoutePage/redux/selectors'
import { commonSelector } from '../Common/redux/selectors';
import WhiteCard from '../CommonResp/WhiteCard/WhiteCard';
import FAQ from '../CommonResp/FAQ/FAQ';
import Footer from '../CommonResp/Footer/Footer';
import Carousel from '../CommonResp/Carousel/Carousel';
import SrpLeftBlock from './SrpLeftBlock/SrpLeftBlock';
import { filterCollapse } from './../../SEOContainer/RoutePage/redux/actions'
import getDateObj from './../Common/utils/GetDateObj';
import { redirectToFunnel } from '../Common/utils/redirectToFunnel';
import format_BusQueryDate from './../Common/utils/QueryDateFormat';
import { prepareRespSRPURL, isMobileView, getInitSelectedFilters } from '../Common/utils';
import MobileHeader from '../CommonResp/MobileHeader/MobileHeader';
import { Helmet } from 'react-helmet';
import { getOperatorView, getBPDPView, getHotelsView } from './../CommonResp/CrossLinkFunction'
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import dateformat from 'dateformat';
import TemplateContent from '../CommonResp/Content/Content';
import { getBreadCrumbObj } from './../CommonResp/utils';
import SeoContainerHeader from "../Common/SeoContainerHeader";
import BusTrainPassWidget from '../CommonResp/BusTrainPassWidget';
import Informationwidget from '../CommonResp/InfomationWidget';
import PageNotFound from '../CommonResp/PageNotFoud/PageNotFound';
import AdBanner from './../../components/AdBanner/AdBanner';
import CrossTemplate from '../CommonResp/CrossTemplate/CrossTemplateTile';
import { calculateDaysToTrip, convert_yyyymmdd_to_dd_mm_dddd, ctaHelper, CTA_TYPE, trackActionEvent, sendPageViewEvent, calculateDroppingDate } from '../../utils/Omniture';
import { PAGE_NAMES } from '../config/constants';


const RouteRespPage = (props) => {

  const { isCategoryPage = false, isOperatorPage = false, isOperatorTypePage = false, pageType = "" } = props;
  const commonData = useSelector(commonSelector);
  const data = useSelector(routeDataSelector);
  const isBusAvailable = useSelector(busAvailableSelector);
  const isDumpData = useSelector(dumpDataSelector);
  const rawData = useSelector(srpDataSelector);
  const { journeyType, filterStr, operator_id, operator_name } = commonData
  const { privateAvailableBuses, otherPrivateAvailableBuses } = useSelector(srpPrivateBusesSelector);
  const { rtcBuses } = useSelector(srpRTCBusesSelector);
  const isOtherPrivateBusesAvailable = otherPrivateAvailableBuses && otherPrivateAvailableBuses[journeyType] && otherPrivateAvailableBuses[journeyType].length ? true : false;
  const [showClientContent, enableClient] = useState(false);
  const { bus_op, offers, src, dest, src_id, dest_id, date, seo_meta = {}, template, canonical_url, footer_links, total_buses, operatorName, operatorId,
  cross_template_links = {}, htl_city_links = {}, dest_hotels = {}, dummy_data, bus_type, reverse_slug, src_dump, general_contents = [],
  basic_info = {}, notToCrawl = false, bus_data ={}, dest_state_name='', src_state_name = '', city_info={}, notToIndex=false } = data;
  const {dest_city, routeState, src_city} = city_info
  useEffect(() => {
    enableClient(true);
  }, []);
  useEffect(()=>{
        let pageName = ''
        if(isCategoryPage){
          pageName =  PAGE_NAMES.route_category
        }
        else if(isOperatorPage){
          pageName =  PAGE_NAMES.route_operator
        }
        else if(isOperatorTypePage){
          pageName =  PAGE_NAMES.route_operator_category
        }
       else{
        pageName = PAGE_NAMES.route
      }
       const eventDetails = {
        pageName: pageName,
        booking: {
          routeCity: `${src_city}-${dest_city}`,
          routeState: `${routeState}`,
          daysToTrip: calculateDaysToTrip(dateObj),
          departureDate: convert_yyyymmdd_to_dd_mm_dddd(dateObj),
        }
       }
       sendPageViewEvent(eventDetails)
  },[]);
   
  const { content = "", faq = {}, contents = [] } = template || {};
  const { info, title } = basic_info;
  const { operators = []} = bus_data
  const { bp, dp } = (() => {
    let bp = [];
    let dp = [];
    if (rawData && rawData.bp_dict && Object.keys(rawData.bp_dict).length) {
      bp = Object.keys(rawData.bp_dict)
    }
    if (rawData && rawData.dp_dict && Object.keys(rawData.dp_dict).length) {
      dp = Object.keys(rawData.dp_dict)
    }
    return { bp, dp }
  })();

  let filterStrView = ''
  let primaryFilters = []
  let operatorFilterList = []
  let operatorObj = {}

  if (filterStr && filterStr.length) {
    filterStrView = filterStr.toUpperCase().split("-").join(" ")
    let str = filterStr.toLowerCase();
    if (str.indexOf('non-ac') !== -1) {
      primaryFilters.push('nonac');
      str = str.replace('non-ac', '')
    }
    if (str.indexOf('semi-sleeper') !== -1) {
      primaryFilters.push('sleeper');
      str = str.replace('semi-sleeper', '')
    }
    if (str.indexOf('mercedes-benz') !== -1) {
      primaryFilters.push('mercedes-benz');
      str = str.replace('mercedes-benz', '')
    }
    const types = str.split("-");
    primaryFilters = primaryFilters.concat(types);
  }

  const getRouteSlug = () => {
    let routeSlug = `Buses from ${dest} to ${src}`
    if (isCategoryPage) {
      routeSlug = `${filterStrView || ''} Buses from ${dest} to ${src}`
    }
    if (isOperatorPage) {
      routeSlug = `${operatorName || ''} Buses from ${dest} to ${src}`
    }
    if (isOperatorTypePage) {
      routeSlug = `${operatorName || ''} ${bus_type || ''} Buses from ${dest} to ${src}`
    }
    return routeSlug
  }

  const reverseLinkMessage = (() => {
    return ` View ${getRouteSlug()}`
  })();

  if (isOperatorPage) {
    operatorFilterList.push(operator_id);
    operatorObj = { [operator_id]: operatorName }
  }

  const adTechId = (() => {
    let id = "QlVTI1JPVVRFIFNFTyNWSUVXIE1PUkUgQlVTRVM="
    // if (isCategoryPage) {
    //   id = ""
    // } else if (isOperatorPage) {
    //   id = ""
    // } else if (isOperatorTypePage) {
    //   id = ""
    // }
    return id
  })();

  const { topOperatorView, isTopOperatorDataPresent } = getOperatorView(bus_op);
  const { bpView, dpView, isBPPresent, isDPPresent } = getBPDPView(bp, dp);
  const renderOfferCarousel = showClientContent && offers && offers.length ? true : false;
  const [selectedFilters, setSelectedFilters] = useState(getInitSelectedFilters({ operators: operatorObj, filterStr: filterStr }));
  const { filters } = useSelector(routePageFilterSelector);
  const { view: htl_city_links_view_data, isDataPresent: is_htl_city_links_present } = getHotelsView(htl_city_links)
  const { view: dest_hotels_view_data, isDataPresent: is_dest_hotels_present } = getHotelsView(dest_hotels)

  const onUpdateSearch = ({ src_name, dest_name, src_id, dest_id, selectedDate, dest_autosuggest = false, src_autosuggest = false, calendar_select = false }) => {
    // if (dummy_data) {
    //   window.location.href = 'https://www.goibibo.com/bus/';
    //   return;
    // }
    let srpObj = { src: src_name, dest: dest_name, src_id: src_id, dest_id: dest_id, date: selectedDate, selectedFilters, dest_autosuggest, src_autosuggest, calendar_select }

    if ((isCategoryPage || isOperatorPage) && isBusAvailable) {
      srpObj['isFilter'] = true;
    }

    if (isBusAvailable) {
      srpObj['filters'] = selectedFilters;
    }

    const srpURL = prepareRespSRPURL(srpObj);

    const eventDetails = {
      search: {
        searchId: `${src_name}_${dest_name}_${selectedDate}`,
      },
      cta: ctaHelper(['Update_Search', CTA_TYPE.BUTTON, 'Header', 'SRP']),
      booking: {
        routeCity: `${src_city}-${dest_city}`,
        routeState: `${routeState}`,
        daysToTrip: calculateDaysToTrip(dateObj),
        departureDate: convert_yyyymmdd_to_dd_mm_dddd(dateObj),
      },
    };
    trackActionEvent("busUpdateSearch", eventDetails);

    window.location.href = `${__ENV_CONFIG__.__GOIBIBO__}${srpURL}`;
  }

  const dateObj = (() => {
    if (date) {
      return getDateObj(format_BusQueryDate(date));
    } else {
      return getDateObj();
    }
  })();

  const mobileView = isMobileView();
  const isCarouselMob = !renderOfferCarousel && !mobileView

  // const screenWidth = function (){
  //   let w = 300;
  //   if(typeof document !== "undefined" &&  document && document.body && document.body.clientWidth){
  //     w = document.body.clientWidth;
  //   }
  //   return w;
  // }()

  const isPreviousDateAllowed = (() => {
    try {
      return new Date().getTime() < dateObj.getTime() ? true : false
    } catch (err) {
      console.error(err);
    }
    return false;
  })();
  
  /******************************** */
  const track = (params)=>{
    if(params.rtcId){
     // rtc bus
      return ;
    }
   const mweb = isMobileView();
   let selectedBus;
   if(mweb){
    selectedBus = params.data;
   }else{
    const buses = privateAvailableBuses[journeyType];
    let skuIndex = buses?.findIndex((item)=> item.fh===params.routeId);
    selectedBus = buses[skuIndex] || {};
   }
    const {
      operatorName,
      rating,
      departureTime,
      duration,
      arrivaleTime,
      seatsAvailable,
      aws,
      bid,
      is_nitro,
      card_BPDP_Info
    } = selectedBus;

    const eventDetails = {
      search: {
        searchId: `${src}_${dest}_${date}`,
      },
      cta: ctaHelper(['Select_Seats', CTA_TYPE.BUTTON, 'Header', 'SRP']),
      "productListItems": [{
        "SKU": bid, 
        "productInfo": {
            "productName": operatorName,
            "productPosition": "index",
            "busNitroDealsBanner": is_nitro ? "yes": "no",
            "busLoginDealsBanner": "[yes/no]",
        }
    }],
      booking: {
        routeCity: `${src_city}-${dest_city}`,
        routeState: `${routeState}`,
        daysToTrip: calculateDaysToTrip(dateObj),
        departureDate: convert_yyyymmdd_to_dd_mm_dddd(dateObj),
        departureTime: departureTime,
        droppingTime: arrivaleTime,
        duration: duration,
        AvailabeSeats: seatsAvailable,
        AvailabeWindowSeats: aws,
        Ratings: rating?rating:'',
        seatNumber:"",
        numberOfSeats:"",
        baseFare: "",
        taxAmount: "",
        discount: ""
      },
    };
    
    trackActionEvent("busResultClick",eventDetails,{global:true});
    
  } 
  
  const moveToFunnel = (params) => {
    const _data = {
      src_name: src,
      dest_name: dest,
      src_id: src_id,
      dest_id: dest_id
    }
     redirectToFunnel({ ...params, data: { ...params.data, ..._data }, data_date: date });
  }
  
  const { h1_title = "", meta_title = "", meta_description = "", meta_keywords = "", breadcrumb = "" } = seo_meta;
  const breadCrumbObj = getBreadCrumbObj(breadcrumb, canonical_url);
  const isListingAvailable = (isBusAvailable || (isOtherPrivateBusesAvailable && (isCategoryPage || isOperatorPage)));

  return (
    <>
      <Helmet
        title={meta_title}
        meta={
          [{ name: 'description', content: meta_description },
          { name: 'keywords', content: meta_keywords },
          { property: 'og:title', content: meta_title },
          { property: 'og:description', content: meta_description },
          { property: 'og:image', content: 'https://gos3.ibcdn.com/bus-default-1489655303.jpg' },
          { property: 'og:url', content: canonical_url },
          notToCrawl ? { name: 'robots', content: 'noindex,nofollow' } : '',
          notToIndex ? { name: 'robots', content: 'noindex' } : '',
          ]
        }
        link={[{ href: canonical_url, rel: 'canonical' }]}
      />

      {notToCrawl ?
        <PageNotFound src={src}
          dest={dest}
          src_id={src_id}
          dest_id={dest_id}
          date={date}
          onUpdateSearch={onUpdateSearch}
          showHeaderOnly={notToCrawl}
          footer_links={footer_links}
        ></PageNotFound>
        :
        <>
          <Helmet>
            <script type="application/ld+json">{`${JSON.stringify(breadCrumbObj)}`}</script>
          </Helmet>
          <div className="seoContainer">
            <div className="desktopOnly">
              <SeoContainerHeader
                src={src}
                dest={dest}
                src_id={src_id}
                dest_id={dest_id}
                date={date}
                onUpdateSearch={onUpdateSearch}
                showCalendar
              />
            </div>
            {showClientContent && mobileView ?
              <MobileHeader
                title={`${src} to ${dest}`}
                date={date}
                src={src}
                dest={dest}
                srpDate={date}
                src_id={src_id}
                dest_id={dest_id}
                page={'route_page'}
                operatorName={operatorName}
                operatorId={operatorId}
                moveToFunnel={(params) => { 
                  moveToFunnel({ ...params, isFilter: (isCategoryPage || isOperatorPage) ? true : false, selectedFilters: (isCategoryPage || isOperatorPage) ? selectedFilters : {} }); 
                }}
                onUpdateSearch={() => { onUpdateSearch({ src_name: src, dest_name: dest, src_id, dest_id, selectedDate: date }) }}>
              </MobileHeader> : null}

            <div className="ContentWrapper" >
              <div className="contentSection">
                <div className="RgtSection">
                  <Heading content={h1_title}></Heading>
                  <Breadcrumbs content={breadcrumb}></Breadcrumbs>
                  <TemplateContent data={general_contents} className="seoDescTitle"></TemplateContent>

                  {isListingAvailable ? <>
                    <div className="searchInfoSection">
                      <div className="busCountSection">
                        {total_buses && +total_buses > 0 ? <>
                          <span>Showing</span>
                          <span className="busCountTxt">{`${total_buses} buses`}</span>
                        </> : null}
                      </div>

                      <div className="busNextPrev">
                        {isPreviousDateAllowed ? <>
                          <span className="busDay" onClick={() => {
                            const currentDate = dateObj;
                            currentDate.setDate(currentDate.getDate() - 1);
                            onUpdateSearch({ src_name: src, dest_name: dest, src_id: src_id, dest_id: dest_id, selectedDate: dateformat(currentDate, 'yyyymmdd') })
                          }}>Previous Day</span>
                          <span className="barSection">|</span>
                        </> : null}
                        <span className="busDay" onClick={() => {
                          const currentDate = dateObj;
                          currentDate.setDate(currentDate.getDate() + 1);
                          onUpdateSearch({ src_name: src, dest_name: dest, src_id: src_id, dest_id: dest_id, selectedDate: dateformat(currentDate, 'yyyymmdd') })
                        }}>Next Day</span>
                      </div>
                    </div>
                  </>
                    : null}

                  {isListingAvailable ?
                    <>
                      <SortBy onClick={evt => {
                        const val = evt.target.dataset.val;
                        if (val) {
                          const data = {
                            "sort": {
                              "sortOption": val
                            }
                          }
                          trackActionEvent("sortApplied", data);
                          moveToFunnel({ page: 'srp', sortBy: val, isFilter: (isCategoryPage || isOperatorPage) ? true : false, selectedFilters: (isCategoryPage || isOperatorPage) ? selectedFilters : {} })
                        }
                      }} />

                      {(privateAvailableBuses && privateAvailableBuses[journeyType] && privateAvailableBuses[journeyType].length) || (rtcBuses && Object.keys(rtcBuses).length) ?
                        <>
                          <Listing privateBuses={privateAvailableBuses[journeyType]} rtcBuses={rtcBuses} dummy_data={dummy_data} showHeading={true} operators={operators}
                            moveToFunnel={(data) => { 
                              track(data);
                              moveToFunnel({ ...data, isFilter: (isCategoryPage || isOperatorPage) ? true : false, selectedFilters: (isCategoryPage || isOperatorPage) ? selectedFilters : {} }) }} 
                            src_dump={src_dump} showClientContent={showClientContent} ></Listing>

                          {showClientContent ? <div className="viewMoreBuses cpointer" onClick={() => {
                            moveToFunnel({ page: 'srp', viewMoreBuses: true, isFilter: (isCategoryPage || isOperatorPage) ? true : false, selectedFilters: (isCategoryPage || isOperatorPage) ? selectedFilters : {} })
                          }}>{`VIEW MORE ${isOperatorPage ? operatorName : filterStrView} BUSES`}</div> : null}
                        </> : <></>}

                      {isOtherPrivateBusesAvailable ?
                        <div className='marginT10'>
                          <Heading otherBuses={true} content={`${src} to ${dest} Other Buses`}></Heading>
                        </div>
                        : <></>}
                      {isOtherPrivateBusesAvailable ? <Listing privateBuses={otherPrivateAvailableBuses[journeyType]} dummy_data={dummy_data} moveToFunnel={moveToFunnel} src_dump={src_dump} showClientContent={showClientContent} showHeading={false}></Listing> : null}

                      {showClientContent && isOtherPrivateBusesAvailable ?
                        <div className="viewMoreBuses cpointer"
                          onClick={() => {
                            moveToFunnel({ page: 'srp', viewMoreBuses: true })
                          }}>{`VIEW MORE BUSES`}</div> : <></>}
                    </> :
                    <>
                      {/* <NoBusFound /> */}
                    </>
                  }
                </div>

                <div className={`LftSection`}>
                  {renderOfferCarousel && !mobileView ? <Carousel content={offers} count={isMobileView() ? offers.length : 1} lazyload={false}></Carousel> : null}
                  {showClientContent && isListingAvailable && !mobileView ?
                    <SrpLeftBlock
                      selectedFilters={selectedFilters}
                      setSelectedFilters={setSelectedFilters}
                      filters={filters}
                      filterCollapse={filterCollapse}
                      operatorDisplayName={operatorName}
                      onClickCb={(data) => {
                        moveToFunnel({ page: 'srp', isFilter: data.isFilter, selectedFilters: data.filters });
                      }}
                    ></SrpLeftBlock>
                    : <></>}
                </div>
              </div>

              {showClientContent && isBusAvailable ?
                <ReverseTile content={reverseLinkMessage} link={reverse_slug}></ReverseTile> : <></>}

              {showClientContent ? <AdBanner cid={adTechId} /> : <></>}

              <Informationwidget data={info} title={title}></Informationwidget>

              {showClientContent ? <BusTrainPassWidget /> : <></>}

              <TemplateContent className="whiteCard" data={contents} content={content}></TemplateContent>

              <FAQ data={faq}></FAQ>

              <WhiteCard content={topOperatorView} heading={`Popular Bus Operators in ${src}`} isContent={isTopOperatorDataPresent}></WhiteCard>

              <div className="whiteCardWrapper">
                <Tile tileHeading={`Boarding points in ${src}`} tileContent={bpView} isTileContent={isBPPresent}></Tile>
                <Tile tileHeading={`Dropping points in ${dest}`} tileContent={dpView} isTileContent={isDPPresent}></Tile>
                <CrossTemplate cross_template_links={cross_template_links} />

                {htl_city_links && htl_city_links.length ?
                  <Tile tileHeading={`Top hotels in ${dest}`} tileContent={htl_city_links_view_data} isTileContent={is_htl_city_links_present}></Tile> : null}

                {dest_hotels && dest_hotels.length ?
                  <Tile tileHeading={`Popular hotels in ${dest}`} tileContent={dest_hotels_view_data} isTileContent={is_dest_hotels_present}></Tile> : null}
              </div>
            </div>
            <Footer data={footer_links}></Footer>
          </div>
        </>
      }
    </>
  )
}

export default RouteRespPage;
